export default "__VITE_ASSET__e6e91ce4__"